module.exports = __webpack_public_path__ + "static/media/banner3.033d19f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/style/imgs/all/banner3.png
// module id = 1844
// module chunks = 1